import { notifyParent } from 'mailup-react-helpers'

export const goToFattureInCloudConnector = (): void => {
  notifyParent('redirectMainFrame', [
    `settings_app_redirector.aspx?r=${encodeURIComponent(
      '/settings/integrations/connectors/fatture-in-cloud-connector',
    )}`,
  ])
}
